// export const url = 'http://dong.cn:80/index.php/index/index/'              
import { get, post } from './http'
export const url =  'http://wxdj.htpig.cn:9006/index.php/index/'
export const url2 = 'http://wxdj.htpig.cn:9006/index.php/index/index/'

export const login = p => get(url+'index/useradmin', p) 
export const changePwd = p => get(url+'index/changePass', p) 


export const adminList = p => get(url+'admin/adminList', p) 
export const adminAdd = p => get(url+'admin/adminAdd', p) 
export const adminEdit = p => get(url+'admin/adminEdit', p) 
export const adminDel = p => get(url+'admin/adminDel', p) 

export const powerList = p => get(url+'admin/powerList', p) 
export const powerAdd = p => get(url+'admin/powerAdd', p) 
export const powerEdit = p => get(url+'admin/powerEdit', p) 
export const powerDel = p => get(url+'admin/powerDel', p) 

export const carList = p => get(url+'admin/carList', p) 
export const carListAll = p => get(url+'admin/carListAll', p) 
export const carAdd = p => get(url+'admin/carAdd', p) 
export const carEdit = p => get(url+'admin/carEdit', p) 
export const carDel = p => get(url+'admin/carDel', p) 

export const ykList = p => get(url+'admin/ykList', p) 
export const ykListAll = p => get(url+'admin/ykListAll', p)     
export const ykAdd = p => get(url+'admin/ykAdd', p) 
export const ykEdit = p => get(url+'admin/ykEdit', p) 
export const ykMingxi = p => get(url+'admin/ykMingxi', p) 

export const ykList2 = p => get(url+'admin/ykList2', p) 
export const ykAdd2 = p => get(url+'admin/ykAdd2', p) 
export const ykEdit2 = p => get(url+'admin/ykEdit2', p) 
export const ykMingxi2 = p => get(url+'admin/ykMingxi2', p) 

export const bblogin = p => get(url+'baob/bblogin', p) 
export const bblist = p => get(url+'baob/bblist', p) 
export const bblist2 = p => get(url+'baob/bblist2', p) 
export const bblist3 = p => get(url+'baob/bblist3', p) 
export const bblistmyy = p => get(url+'baob/bblistmyy', p) 

export const wsAdd = p => get(url+'wushui/wsAdd', p) 
export const wsList = p => get(url+'wushui/wsList', p) 
export const wsDel = p => get(url+'wushui/wsDel', p) 


export const staffList = p => get(url+'admin/staffList', p) 
export const staffAdd = p => get(url+'admin/staffAdd', p) 
export const staffEdit = p => get(url+'admin/staffEdit', p) 
export const staffDel = p => get(url+'admin/staffDel', p) 


